import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_CANDIDATEFILTER, REACT_APP_JOB, REACT_APP_RECRUITER } from "../../utils/common"

export async function getCandidates(pageSize: number, pageNumber: number, searchValue: string, body?: any){
    const Details = postAPI(REACT_APP_CANDIDATEFILTER + `/filter-csr-candidate?page=${pageNumber}&size=${pageSize}&search=${searchValue}`, body)
    return Details
}

export async function applyCandidateToJobByCSRecruiter(body: any){
    const Details = postAPI( REACT_APP_JOB  + `/csrecruiter-candidate-job`, body)
    return Details
}

export async function getAllocatedto() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}

export async function getJob(jobId: string){
    const Details = getAPI( REACT_APP_JOB + `/position/${jobId}?userRole=CS-RECRUITER`)
    return Details
  }